import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import "./Footer.css";

// 🔹 Assets
import ottomunHeader from "../assets/ottoheader.png";
import pearsonLogo from "../assets/pearson.png";
import majoleLogo from "../assets/majole.png";
import globiseLogo from "../assets/globise.png";

const Footer = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const message = e.target.elements.message.value;
    window.location.href = `mailto:info@ottomun.org?subject=Conference%20Contact&body=${encodeURIComponent(
      message
    )}`;
  };

  return (
    <footer className="footer">
      <div className="footer-content">

        {/* 🔹 LEFT SIDE - Logo + Info */}
        <div className="footer-left">
          <img src={ottomunHeader} alt="Ottomun" className="footer-logo-main" />

          <p>
            Ottomun is a prestigious Model United Nations (MUN) organization
            dedicated to empowering youth in diplomacy, debate, and global leadership.
          </p>

          <p><FaMapMarkerAlt /> Istanbul, Türkiye</p>
          <p><FaEnvelope /> info@ottomun.org</p>
          <p><FaPhoneAlt /> +90 (212) 234 39 00</p>
        </div>

        {/* 🔹 MIDDLE LINKS */}
        <div className="footer-middle-links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/apply">Apply</Link></li>
            <li><Link to="/academic-team">Academic Team</Link></li>
            <li><Link to="/committees">Committees</Link></li>
            <li><Link to="/conduct">Code of Conduct</Link></li>
          </ul>
        </div>

        {/* 🔹 CONTACT FORM */}
        <div className="footer-middle">
          <h3>Contact Us</h3>
          <form className="footer-form" onSubmit={handleSubmit}>
            <textarea
              name="message"
              placeholder="Write your message here..."
              required
            />
            <button type="submit">Send</button>
          </form>
        </div>

        {/* 🔹 PARTNERS */}
        <div className="footer-right">
          <h3>Our Partners</h3>

          <div className="partner-list">
            <a href="https://www.majole.com" target="_blank" rel="noopener noreferrer">
              <img src={majoleLogo} alt="Majole" />
            </a>

            <a href="https://english-dashboard.pearson.com" target="_blank" rel="noopener noreferrer">
              <img src={pearsonLogo} alt="Pearson" />
            </a>

            <a href="https://globise.com" target="_blank" rel="noopener noreferrer">
              <img src={globiseLogo} alt="Globise" />
            </a>
          </div>
        </div>

      </div>

      {/* 🔹 SOCIAL BAR */}
      <div className="footer-bottom">
        <p>Follow us on social media</p>

        <div className="social-icons">
          <a
            href="https://www.instagram.com/sharronxenos_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.youtube.com/@majoleeducation4028"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>
        </div>

        <p>© 2025 Ottomun Society. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
